import { Component, Signal } from '@angular/core';
import { Navbar } from '../../components/shared/navbar/navbar.component';
import { BusinessConfiguration } from '../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../state-management/services/website-state.service';

@Component({
  selector: 'app-accessibility',
  imports: [Navbar],
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.scss'
})
export class AccessibilityComponent {
  public metaData: Signal<BusinessConfiguration> = this.websiteState.configuration;
  
    constructor(
      private websiteState: WebsiteStateService
    ) { }
  
    ngOnInit() {
     }
}
